import { useTranslation } from 'react-i18next';
import { STATUS_COLORS, type OrderStatus } from '@/lib/orders-client';

// Maps backend order-status enum values → their 'orders' locale key (status.*).
// Never send these keys to the API; they are for rendering only.
export const ORDER_STATUS_KEYS: Record<OrderStatus, string> = {
    draft: 'draft',
    pending: 'pending',
    confirmed: 'confirmed',
    completed: 'completed',
    pending_payment: 'pendingPayment',
    pos_push_failed: 'posPushFailed',
    pushed_to_external_pending: 'pushedToExternalPending',
    pushed_to_external: 'pushedToExternal',
    cancelled: 'cancelled',
    abandoned: 'abandoned',
};

interface OrderStatusBadgeProps {
    status: OrderStatus;
}

export function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
    const { t } = useTranslation('orders');
    const colorClass = STATUS_COLORS[status];

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
            {t(`status.${ORDER_STATUS_KEYS[status]}`)}
        </span>
    );
}
